<template>
    <div id="page" v-loading="loading">
        <div class="flex pad14 alc" id="toolH">
            <el-input
                    style="width: 220px"
                    class="marr4"
                    size="small"
                    placeholder="搜索"
                    clearable
                    v-model="vc_search">
            </el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="gotoPage('add')">新增</el-button>
            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="toSave">批量保存</el-button>
        </div>
        <el-table

                ref="table"
                size="mini"
                border
                :data="tableData"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :row-class-name="rowClassName">
            <el-table-column
                    type="index"
                    label="序号">
            </el-table-column>
            <el-table-column
                    type="index"
                    label="公司"
                    width="200">
                <template slot-scope="scope">
                    <el-select v-if="scope.row.edit" class="wid100"  @change="changegsData(scope.row)"  v-model="scope.row.vc_gsname" size="mini" clearable filterable >
                        <el-option
                                v-for="item in gsList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                    <span v-else>{{scope.row.vc_gsname}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    type="index"
                    label="车间"
                    width="200">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.edit" class="wid100"  @change="changekhData(scope.row)"  v-model="scope.row.vc_cjname" size="mini" clearable filterable >
                            <el-option
                                    v-for="item in scope.row.khList"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.vc_name">
                            </el-option>
                        </el-select>
                        <span v-else>{{scope.row.vc_cjname}}</span>
                    </template>
            </el-table-column>
            <el-table-column
                    type="index"
                    label="产品"
                    width="200">
                <template slot-scope="scope">
                    <el-select v-if="scope.row.edit" class="wid100" @focus="getpzdata(scope.row)"  @change="changepzData(scope.row)"   v-model="scope.row.vc_pzname" size="mini" clearable filterable >
                        <el-option
                                v-for="item in pzList"
                                :key="item.i_id"
                                :label="item.vc_pzname"
                                :value="item.vc_pzname">
                        </el-option>
                    </el-select>
                    <span v-else>{{scope.row.vc_pzname}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    type="index"
                    label="类型"
                    width="115">
                <template slot-scope="scope">
                    <el-select v-if="scope.row.edit" class="wid90"  @change="changetype(scope.row)"  v-model="scope.row.i_type" size="mini"  filterable >
                        <el-option
                                v-for="item in typeList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                    <span v-else>{{scope.row.i_type==1?'公用':'车间'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    type="index"
                    label="核算区域"
                    width="180">
                <template slot-scope="scope">
                    <el-select v-if="scope.row.edit" :disabled="scope.row.i_type==0?true:false" class="wid100"   @change="changeqyData($event,scope.$index)"  v-model="scope.row.vc_hs_region" size="mini" filterable >
                        <el-option
                                v-for="item in qyList"
                                :key="item.i_id"
                                :label="item.vc_hs_region"
                                :value="item.vc_hs_region">
                        </el-option>
                    </el-select>
                    <span v-else>{{scope.row.vc_hs_region}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    type="index"
                    label="人工分配系数"
                    width="115">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit" @input.native="inpU" @change="formatter(scope.row,'rg')" class="wid90" size="mini"  v-model="scope.row.f_artificial_coefficient">
                    </el-input>
                    <span v-else>{{scope.row.f_artificial_coefficient}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    type="vc_credit_insurance"
                    label="制造分配系数"
                    width="115">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit"  @input.native="inpU" @change="formatter(scope.row,'zz')" class="wid90" size="mini"  v-model="scope.row.f_manufacturing_coefficient">
                    </el-input>
                    <span v-else>{{scope.row.f_manufacturing_coefficient}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    type="f_credit_insurance"
                    label="水分配系数"
                    width="115">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit"  @input.native="inpU" @change="formatter(scope.row,'s')" class="wid90" size="mini"  v-model="scope.row.f_water_coefficient">
                    </el-input>
                    <span v-else>{{scope.row.f_water_coefficient}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    type="f_credit_insurance"
                    label="电分配系数"
                    width="115">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit"  @input.native="inpU" @change="formatter(scope.row,'d')" class="wid90" size="mini"  v-model="scope.row.f_electricity_coefficient">
                    </el-input>
                    <span v-else>{{scope.row.f_electricity_coefficient}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    type="f_credit_insurance"
                    label="蒸汽分配系数"
                    width="115">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit"  @input.native="inpU" @change="formatter(scope.row,'zq')" class="wid90" size="mini"  v-model="scope.row.f_steam_coefficient">
                    </el-input>
                    <span v-else>{{scope.row.f_steam_coefficient}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    type="f_credit_insurance"
                    label="天然气分配系数"
                    width="115">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit"  @input.native="inpU" @change="formatter(scope.row,'trq')" class="wid90" size="mini"  v-model="scope.row.f_natural_gas_coefficient">
                    </el-input>
                    <span v-else>{{scope.row.f_natural_gas_coefficient}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="120"
                    label="操作">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.edit==false"  type="text" size="small" @click="goEdit(tableData,scope.$index,scope.row)">编辑</el-button>
                    <el-button v-else  type="text" size="small" @click="goEditsave(tableData,scope.$index,scope.row)">保存</el-button>
                    <el-button style="color: red" type="text" size="small" @click="godelete(tableData,scope.$index,scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <div :class="baseerp+'div'" class="cgdia">
            <el-dialog
                    width="500px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <add-page :data="addData" @close="cancelDialog"></add-page>
            </el-dialog>
        </div>
    </div>

</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    //import addPage from "./addPage";
    export default {
        components: {
            //addPage
        },
        data() {
            return {
                dels:[],
                qyList:[],
                typeList:[
                    {i_id:0,vc_name:'车间'},
                    {i_id:1,vc_name:'公用'}
                ],
                pzList:[],
                khList:[],
                nalList:[],
                nalList2:[],
                i_national:0,
                vc_national:'全部',
                vc_search:"",
                addData:{},
                title:'新增',
                dialogVisible:false,
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                baseerp:"",
                file_root:"",
                mid:0,
                tableData:[
                ],
                loading:false,
                tableHeight:0,
                gsList:[],
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            //this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.file_root = file_root;
            this.listRegion()
            this.getCompanyList();
            this.getlist();
            this.$nextTick(function () {
                this.onResize();
            });
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 100;
                //this.tableHeight = $("#page").height()*1 -  $("#toolH").height()*1 ;
                //console.log(n.h,this.tableHeight)
            },
            parser(value) {
                // 将输入值转换为数字类型，如果为空则返回 null，Element UI 会处理为 undefined 或空字符串
                return value === '' ? null : Number(value);
            },
            formatter(val,type) {
                if(type=='rg'){
                    // 如果值为整数，则不显示小数点；否则原样返回（显示小数
                    let value = Number(val.f_artificial_coefficient);
                    //console.log('value--------',Number.isInteger(value));
                    value = value === null ? '' : (Number.isInteger(value) ? value : parseFloat(value).toFixed(2));
                    //console.log('value--------end',value);
                    this.tableData[val.index].f_artificial_coefficient = value;
                    this.$forceUpdate()
                }
                if(type=='zz'){
                    // 如果值为整数，则不显示小数点；否则原样返回（显示小数
                    let value = Number(val.f_manufacturing_coefficient);
                    value = value === null ? '' : (Number.isInteger(value) ? value : parseFloat(value).toFixed(2));
                    this.tableData[val.index].f_manufacturing_coefficient = value;
                    this.$forceUpdate()
                }
                if(type=='s'){
                    // 如果值为整数，则不显示小数点；否则原样返回（显示小数
                    let value = Number(val.f_water_coefficient);
                    value = value === null ? '' : (Number.isInteger(value) ? value : parseFloat(value).toFixed(2));
                    this.tableData[val.index].f_water_coefficient = value;
                    this.$forceUpdate()
                }
                if(type=='d'){
                    // 如果值为整数，则不显示小数点；否则原样返回（显示小数
                    let value = Number(val.f_electricity_coefficient);
                    value = value === null ? '' : (Number.isInteger(value) ? value : parseFloat(value).toFixed(2));
                    this.tableData[val.index].f_electricity_coefficient = value;
                    this.$forceUpdate()
                }
                if(type=='zq'){
                    // 如果值为整数，则不显示小数点；否则原样返回（显示小数
                    let value = Number(val.f_steam_coefficient);
                    value = value === null ? '' : (Number.isInteger(value) ? value : parseFloat(value).toFixed(2));
                    this.tableData[val.index].f_steam_coefficient = value;
                    this.$forceUpdate()
                }
                if(type=='trq'){
                    // 如果值为整数，则不显示小数点；否则原样返回（显示小数
                    let value = Number(val.f_natural_gas_coefficient);
                    value = value === null ? '' : (Number.isInteger(value) ? value : parseFloat(value).toFixed(2));
                    this.tableData[val.index].f_natural_gas_coefficient = value;
                    this.$forceUpdate()
                }
            },
            inpU(event) {
                //console.log('event',event)
                const inputElement = event.target
                const currentValue = inputElement.value
                // 过滤非数字字符
                const sanitizedValue = currentValue.replace(/[^0-9.]/g,'')
                // 如果过滤后的值与当前值不同，说明有非数字字符被移除
                if (currentValue !== sanitizedValue) {
                    // 使用原生 DOM 方法设置过滤后的值
                    inputElement.value = sanitizedValue
                    // 阻止 `el-input-number` 组件内部对输入值的处理
                    event.stopPropagation()
                }
            },
            changeFY(e){
                //console.log(e,'e')
            },
            toSave(){
                let arr=[];
                arr=this.tableData.filter(item=>{
                    return item.edit==true
                })
                //console.log(arr,'arr')
                let kong = arr.some(item=>{
                    return  !item.vc_gsname||!item.vc_cjname||
                        !item.vc_pzname||
                        !item.vc_hs_region||
                        !item.f_artificial_coefficient||
                        !item.f_manufacturing_coefficient||
                        !item.f_water_coefficient||
                        !item.f_electricity_coefficient||
                        !item.f_steam_coefficient||
                        !item.f_natural_gas_coefficient
                })
                //console.log(kong,'kong')
                // if(kong){
                //     this.$message.error('存在输入项为空');
                //     return;
                // }
                this.save(arr);
            },
            //
            async save(arr){
                this.loading=true;
                let param={
                    delIds:this.dels,
                    list:arr,
                };
                let res=await API.save(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.dels=[];
                    this.currentPage=1;
                    this.vc_search='';
                    this.getlist();
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.dels=[];
                this.getlist();
            },
            cancelDialog(){
                this.dialogVisible=false;
            },
            godelete(data,index,row){
                this.$confirm('是否确认删除？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.tableData.splice(index,1)
                    if(row.i_id!=0){
                        this.dels.push(row.i_id)
                        this.save([]);
                    }
                }).catch(() => {

                });

            },
            goEditsave(data,index,row){
                let arr=[];
                arr.push(row);
                let kong = arr.some(item=>{
                    return  !item.vc_gsname||!item.vc_cjname||
                        !item.vc_pzname||
                        !item.vc_hs_region||
                        !item.f_artificial_coefficient||
                        !item.f_manufacturing_coefficient||
                        !item.f_water_coefficient||
                        !item.f_electricity_coefficient||
                        !item.f_steam_coefficient||
                        !item.f_natural_gas_coefficient
                })
                //console.log(kong,'kong')
                // if(kong){
                //     this.$message.error('当前行存在输入项为空');
                //     return;
                // }
                this.save(arr);
            },
            goEdit(data,index,row){
                row.edit=true;
                this.$set(data,index,row)
            },
            gotoPage(type){
                let map={
                    i_id:0,
                    "i_cjid":0, // 车间id
                    "vc_cjname": "", // 车间名
                    "i_pzid": 0, // 产品id
                    "vc_pzname": "", // 产品名
                    "i_type": null, // 类型，1公用，0车间
                    "i_hs_region": 0, // 核算区域
                    "vc_hs_region": "", // 核算区域名
                    edit:true,
                };
                this.tableData.push(map);
                /*if(type=='add'){
                    this.addData={
                        i_id:0,
                    }
                }
                this.dialogVisible=true;*/
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getlist()
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getlist()
            },

            rowClassName({row,rowIndex}){
                row.index=rowIndex
                // console.log(row, row.index,'rowClassName')
            },
            changetype(e){
                let choo = this.typeList.filter(item=>{
                    return item.i_id == e.i_type
                });
                //console.log(choo,'leixing')
                if(choo.length>0){
                    this.tableData[e.index].vc_type=choo[0].vc_name;
                    this.tableData[e.index].i_type=choo[0].i_id;
                    if(this.tableData[e.index].i_type==0){
                        this.qyList=[];
                        this.tableData[e.index].vc_hs_region=this.tableData[e.index].vc_cjname;
                        this.tableData[e.index].i_hs_region=this.tableData[e.index].i_cjid;
                    }else{
                        //this.qyList=[];
                        this.tableData[e.index].vc_hs_region='';
                        this.tableData[e.index].i_hs_region=null;
                        //调区域接口
                        this.listRegion()
                    }
                }else{
                    this.tableData[e.index].vc_type='';
                    this.tableData[e.index].i_type=null;
                    this.qyList=[];
                    //调区域接口
                    this.listRegion()
                }

                this.$nextTick(()=>{
                    this.$forceUpdate()
                })
            },
            getpzdata(row){
                this.pzList=[];
                this.getScorderPzList(row.i_cjid);
            },
            changepzData(e){
                if(this.pzList.length!=0){
                    let choo = this.pzList.filter(item=>{
                        return item.vc_pzname == e.vc_pzname
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.tableData[e.index].vc_pzname=choo[0].vc_pzname;
                        this.tableData[e.index].i_pzid=choo[0].i_id;
                    }else{
                        this.tableData[e.index].vc_pzname='';
                        this.tableData[e.index].i_pzid=0;
                    }
                    this.$nextTick(()=>{
                        this.$forceUpdate()
                    })
                }
            },
            changegsData(e){
                console.log(e,'e');
                if(this.gsList.length!=0){
                    let choo = this.gsList.filter(item=>{
                        return item.vc_name == e.vc_gsname
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.tableData[e.index].vc_gsname=choo[0].vc_name;
                        this.tableData[e.index].i_gsid=choo[0].i_id;
                        this.tableData[e.index].vc_cjname='';
                        this.tableData[e.index].i_cjid=0;
                        this.tableData[e.index].vc_pzname='';
                        this.tableData[e.index].i_pzid=0;
                        this.khtypeList(this.tableData[e.index].i_gsid,e.index)
                    }else{
                        this.tableData[e.index].vc_gsname='';
                        this.tableData[e.index].i_gsid='';
                        this.tableData[e.index].vc_cjname='';
                        this.tableData[e.index].i_cjid=0;
                        this.tableData[e.index].vc_pzname='';
                        this.tableData[e.index].i_pzid=0;
                        this.pzList=[];
                    }
                    this.$nextTick(()=>{
                        this.$forceUpdate()
                    })
                }
            },
            changekhData(e){
                //console.log(e,'e');
                if(this.khList.length!=0){
                    let choo = this.khList.filter(item=>{
                        return item.vc_name == e.vc_cjname
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.tableData[e.index].vc_cjname=choo[0].vc_name;
                        this.tableData[e.index].i_cjid=choo[0].i_id;
                        this.tableData[e.index].vc_pzname='';
                        this.tableData[e.index].i_pzid=0;
                        this.getScorderPzList(this.tableData[e.index].i_cjid)
                    }else{
                        this.tableData[e.index].vc_cjname='';
                        this.tableData[e.index].i_cjid=0;
                        this.tableData[e.index].vc_pzname='';
                        this.tableData[e.index].i_pzid=0;
                        this.pzList=[];
                    }
                    if(this.tableData[e.index].i_type==0){
                        this.qyList=[];
                        this.tableData[e.index].vc_hs_region=this.tableData[e.index].vc_cjname;
                        this.tableData[e.index].i_hs_region=this.tableData[e.index].i_cjid;
                    }
                    this.$nextTick(()=>{
                        this.$forceUpdate()
                    })
                }
            },

            changeqyData(e,index){
                //console.log(e,'e',index,'index');
                //console.log(this.qyList,'this.qyList');
                if(this.qyList.length!=0){
                    let choo = this.qyList.filter(item=>{
                        return item.vc_hs_region == e
                    });
                    //console.log(choo,'choo---')
                    if(choo.length>0){
                        this.tableData[index].vc_hs_region=choo[0].vc_hs_region;
                        this.tableData[index].i_hs_region=choo[0].i_id;
                    }else{
                        this.tableData[index].vc_hs_region='';
                        this.tableData[index].i_hs_region=null;
                    }
                    this.$nextTick(()=>{
                        this.$forceUpdate()
                    })
                    //console.log( this.tableData[index],' this.tableData[index]');
                }
            },
            //调区域接口
            async listRegion(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.listRegion(param);
                if (res.code == 1) {
                    this.qyList = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            // 获取领用部门
            async khtypeList(i_gsid,index){
                let param = {
                    i_mid:this.mid,
                    i_type:1,
                    i_gsid:i_gsid
                };
                let res = await API.getGroupList(param);
                if (res.code == 1) {
                    // this.khList = res.data;
                    // this.tableData[index].khList=res.data;
                    this.$set(this.tableData[index],'khList',res.data)
                    if(res.data.length==1){
                        this.$set(this.tableData[index],'vc_cjname',res.data[0].vc_name)
                        this.$set(this.tableData[index],'i_cjid',res.data[0].i_id)
                        this.getScorderPzList(res.data[0].i_id)
                        // this.tableData[e.index].vc_cjname=choo[0].vc_name;
                        // this.tableData[e.index].i_cjid=choo[0].i_id;
                    }
                    // this.$forceUpdate()
                    // console.log(this.tableData)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            // 获取产品
            async getScorderPzList(cjid){
                let param = {
                    i_mid:this.mid,
                    i_cjid:cjid,
                };
                let res = await API.getScorderPzList(param);
                if (res.code == 1) {
                    this.pzList = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getlist(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_mid:this.mid,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    vc_search:this.vc_search,
                };
                //console.log(param,'param');
                let res=await API.list(param);
                if ( res.code == 1 ){
                    res.data.list.map(item=>{
                        item.edit=false;
                    })
                    this.tableData=res.data.list;
                    this.total=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_mid: this.mid,
                    i_type:"2"
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    this.gsList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style  lang="scss" scoped>
    .wid90{
        width: 90px;
    }
    .wid100{
        width: 150px;
    }
    .alc{
        align-items: center;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:58px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>